import { motion } from "framer-motion";
import { SERVICES } from "../data";
import { useI18n } from "../i18n";

const Card = ({ s, i, t }) => (
  <motion.div
    data-testid={`service-card-${s.id}`}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ y: -6 }}
    className={`group relative overflow-hidden rounded-2xl border border-white/5 bg-[#0F1115] min-h-[280px] ${s.span}`}
  >
    <div className="absolute inset-0">
      <img
        src={s.image}
        alt={t(`services.items.${s.id}.title`)}
        className="w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" />
    </div>
    <div className="absolute inset-0 border border-transparent group-hover:border-cyan-400/40 rounded-2xl transition-colors duration-500 pointer-events-none" />

    <div className="relative z-10 h-full p-7 flex flex-col justify-between">
      <span className="font-mono-accent text-xs tracking-[0.25em] text-cyan">{s.index}</span>
      <div>
        <h3 className="font-display font-700 uppercase tracking-tight text-xl md:text-2xl leading-tight mb-3 group-hover:text-cyan transition-colors duration-300">
          {t(`services.items.${s.id}.title`)}
        </h3>
        <p className="text-neutral-400 text-sm font-light max-w-sm leading-relaxed">
          {t(`services.items.${s.id}.desc`)}
        </p>
      </div>
    </div>
  </motion.div>
);

export const Services = () => {
  const { t } = useI18n();
  return (
    <section id="services" data-testid="services-section" className="relative py-28 md:py-36 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="font-mono-accent text-xs uppercase tracking-[0.3em] text-cyan">{t("services.tag")}</span>
            <h2 className="font-display font-700 uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-none">
              {t("services.title1")} <br />
              <span className="outline-text-white">{t("services.title2")}</span>
            </h2>
          </div>
          <p className="max-w-sm text-neutral-400 font-light">{t("services.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 auto-rows-[280px] gap-5">
          {SERVICES.map((s, i) => (
            <Card key={s.id} s={s} i={i} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
};
